import React from "react"
import Head from "next/head"
import NextNProgress from "../components/NextNProgress"
import { useRouter } from "next/router"
const constants = require('../lib/constants')

import Header from "./Header"
import Footer from "./Footer"
import { Alert } from "./Alert"
import { FormProvider } from "../components/FormContext"
import { BookingProvider } from "../components/BookingContext"
import SSRProvider from "react-bootstrap/SSRProvider"

const Layout = (pageProps) => {
  const router = useRouter()
  const date = new Date();
  const monthName = date.toLocaleString('en-US', { month: 'short' });
  const currentYear = date.getFullYear();
  const fullTitle = pageProps.hideDateSuffix
    ? (pageProps.headlines?.mainTitle || pageProps.title)
    : `${pageProps.headlines?.mainTitle || pageProps.title} - ${monthName} ${currentYear} Ranking`;
  
  const headerProps = {
    nav: {
      classes: pageProps.nav && pageProps.nav.classes,
      fixed: pageProps.nav && pageProps.nav.fixed,
      color: pageProps.nav && pageProps.nav.color,
      light: pageProps.nav && pageProps.nav.light,
      dark: pageProps.nav && pageProps.nav.dark,
    },
    loggedUser: pageProps.loggedUser,
    headerClasses: pageProps.headerClasses
  }

  const getOpenGraphData = () => {
    const ogImage = `${constants.LOGO_URL}/og_directory.png`;
    
    if (pageProps.data && pageProps.data.company) {
      const company = pageProps.data.company;
      
      return {
        title: company.company_name,
        description: pageProps.meta || company.company_description || `Learn about ${company.company_name} - company overview, services, and client reviews.`,
        image: ogImage,
        type: 'business.business',
        businessData: pageProps.data.locations && pageProps.data.locations.length > 0 ? {
          street_address: pageProps.data.locations[0].location_street,
          locality: pageProps.data.locations[0].location_city,
          country_name: pageProps.data.locations[0].location_country?.label
        } : null
      };
    }
    
    return {
      title: fullTitle,
      description: pageProps.meta || `Discover top companies and services on Vendorland.`,
      image: ogImage,
      type: 'website'
    };
  };

  const ogData = getOpenGraphData();
  
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'https://vendorland.com';
  const currentUrl = pageProps.canonical || `${baseUrl}${router.asPath}`;

  return (
    // <SSRProvider>
    // </SSRProvider>
    <div
      style={{ paddingTop: pageProps.noPaddingTop ? "0" : "72px" }}
      className={pageProps.className}
    >
      <Head>
        <title>{fullTitle}</title>
        <link rel="icon" href="/favicon.png" />
        
        <link rel="preconnect" href="https://www.google-analytics.com" />
        <link rel="preconnect" href="https://www.googletagmanager.com" />
        <link rel="dns-prefetch" href="https://www.google-analytics.com" />
        <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
        
        <link rel="preconnect" href="https://media.licdn.com" />
        <link rel="preconnect" href="https://vendorland.com" />
        
        {pageProps.meta ? (
          <meta name="description" content={pageProps.meta} />
        ) : 
        (<meta name="robots" content="noindex"></meta>)
        }
        {pageProps.canonical &&
          <link rel="canonical" href={`${pageProps.canonical}`} />
        }

        {/* Open Graph Tags */}
        <meta property="og:title" content={ogData.title} />
        <meta property="og:description" content={ogData.description} />
        <meta property="og:image" content={ogData.image} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:type" content={ogData.type} />
        <meta property="og:site_name" content="Vendorland.com" />

        {/* Optional business data for company pages */}
        {ogData.businessData && (
          <>
            <meta property="business:contact_data:street_address" content={ogData.businessData.street_address} />
            <meta property="business:contact_data:locality" content={ogData.businessData.locality} />
            <meta property="business:contact_data:country_name" content={ogData.businessData.country_name} />
          </>
        )}

        {/* Twitter Card Tags */}
        <meta property="twitter:site" content="@vendorlandcom" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={ogData.title} />
        <meta property="twitter:description" content={ogData.description} />
        <meta property="twitter:image" content={ogData.image} />
      </Head>
      <NextNProgress color="#4E66F8" options={{ showSpinner: false }} />
      {!pageProps.hideHeader && <Header {...headerProps} />}
      <Alert />
      {pageProps.listingForm ? (
        <React.Fragment>
          {pageProps.listingForm && (
            <FormProvider>
              <main>{pageProps.children}</main>
            </FormProvider>
          )}
        </React.Fragment>
      ) : (
        <main>{pageProps.children}</main>
      )}
      {!pageProps.hideFooter && <Footer />}
    </div>
  );
}

export default Layout
